<template>
  <div name="popup-personaldata">
  	<div class="modal-body detail detail-responsive" >	 
			<div class="detail detail-responsive">

				<div class="detail-block-float detail-block-left">
				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['10'] }}</div>
				      <div class="detail-right">
				          <div class="detail-text  width-100" id="coddesc_codempid" name="coddesc_codempid">{{ dataPersonal.codempid }} - {{ dataPersonal.desc_codempid }}</div>
				      </div>
				  </div>

				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['20'] }}</div>
				      <div class="detail-right">
				          <div class="detail-text  width-100" id="desc_staemp" name="desc_staemp">{{ dataPersonal.desc_staemp }}</div>
				      </div>
				  </div>

				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['30'] }}</div>
				      <div class="detail-right">
				          <div class="detail-text  width-100" id="numlvl" name="numlvl">{{ dataPersonal.numlvl }}</div>
				      </div>
				  </div>

				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['40'] }}</div>
				      <div class="detail-right">
				           <div class="detail-text  width-100" id="dteempmt" name="dteempmt">{{ setDateOutput(dataPersonal.dteempmt) }}</div>
				      </div>
				  </div>

				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['50'] }}</div>
				      <div class="detail-right">
				         <div class="detail-text  width-100" id="dteeffex" name="dteeffex">{{ setDateOutput(dataPersonal.dteeffex) }}</div>
				      </div>
				  </div>

				  <div class="clearfix detail-row">
				      <div class="detail-left label-left">{{ labels['HRES78UC6']['60'] }}</div>
				      <div class="detail-right">
				          <div class="input-group  width-100">
				              <input type="text" class="form-control detail-text" id="serviceyr" name="serviceyr" v-model="dataPersonal.serviceyr" />
				              <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC6']['70'] }}</div>
				          </div>
				          <div class="input-group  width-100">
				              <input type="text" class="form-control detail-text" id="servicemth" name="servicemth" v-model="dataPersonal.servicemth" />
				              <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC6']['80'] }}</div>
				          </div>
				      </div>
				  </div>
				</div>

		    <div class="detail-block-float detail-block-right">		    
	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['90'] }}</div>
	            <div class="detail-right">
	                <div class="detail-text  width-100" id="coddesc_codpos" name="coddesc_codpos">{{ dataPersonal.codpos }} - {{ dataPersonal.desc_codpos }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['100'] }}</div>
	            <div class="detail-right">
	                <div class="detail-text  width-100" id="coddesc_codjob" name="coddesc_codjob">{{ dataPersonal.codjob }} - {{ dataPersonal.desc_codjob }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['110'] }}</div>
	            <div class="detail-right">
	               <div class="detail-text  width-100" id="coddesc_codcomp" name="coddesc_codcomp">{{ dataPersonal.codcomp }} - {{ dataPersonal.desc_codcomp }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['120'] }}</div>
	            <div class="detail-right">
	               <div class="detail-text  width-100" id="coddesc_codempmt" name="coddesc_codempmt">{{ dataPersonal.codempmt }} - {{ dataPersonal.desc_codempmt }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['130'] }}</div>
	            <div class="detail-right">
	               <div class="detail-text  width-100" id="coddesc_typemp" name="coddesc_typemp">{{ dataPersonal.typemp }} - {{ dataPersonal.desc_typemp }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['140'] }}</div>
	            <div class="detail-right">
	               <div class="detail-text  width-100" id="coddesc_typpayroll" name="coddesc_typpayroll">{{ dataPersonal.typpayroll }} - {{ dataPersonal.desc_typpayroll }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['150'] }}</div>
	            <div class="detail-right">
	               <div class="detail-text  width-100" id="coddesc_codcalen" name="coddesc_codcalen">{{ dataPersonal.codcalen }} - {{ dataPersonal.desc_codcalen }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['160'] }}</div>
	            <div class="detail-right">
	                <div class="detail-text  width-100" id="coddesc_codedlv" name="coddesc_codedlv">{{ dataPersonal.codedlv }} - {{ dataPersonal.desc_codedlv }}</div>
	            </div>
	        </div>

	        <div class="clearfix detail-row">
	            <div class="detail-left label-left">{{ labels['HRES78UC6']['170'] }}</div>
	            <div class="detail-right">
	                <div class="input-group  width-100">
	                    <input type="text" class="form-control detail-text" id="amtincom1" name="amtincom1" v-model="dataPersonal.amtincom1" />
	                    <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
	                </div>
	            </div>
		      </div>    
		    </div>

		<div class="clearfix">
          <button type="button" data-toggle="modal" style="margin: 15px 0 0 5px;" class="bg-dark-gray btn"  @click="setShowPersonaldata(!showPersonaldata)" >
            <i class="fa fa-chevron-circle-left"></i> {{ labelsButton['back'] }}
          </button>
        </div>

			</div>
	
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'popup-personaldata',
  props: [ 'showPersonaldata', 'dataPersonal', 'labels', 'labelsButton', 'nowLang', 'setShowPersonaldata', 'approve' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupPersonaldata.vue?51ac9475